import { RTRequest } from '../../../business/cargo';
import { initialRTRequest } from '../../../business/cargo/infra/core/consts';
import { createFeatureContext } from '../../../shared/context';
import { CargoState, CargoUIStatus, initialValue } from './cargo.state';

const { FeatureContextProvider, useFeatureContext } = createFeatureContext<
  CargoState
>(initialValue);

export const CargoProvider = FeatureContextProvider;

export function useCargoContext() {
  const { state, updateState, clearState } = useFeatureContext();

  const clear = () => clearState();
  const setIsOpenDialog = (value: boolean) =>
    updateState({ ...state, isOpen: value, isDropDownOpen: false });

  const setCloseDialog = () => clearState();

  const setIsOpenDropDown = (value: boolean) =>
    updateState({ ...state, isDropDownOpen: value });

  const setOpenCancelDialog = (selectedOrder: number) =>
    updateState({ ...state, isOpenCancelDialog: true, selectedOrder });

  const setCloseCancelDialog = () =>
    updateState({ ...state, isOpenCancelDialog: false });

  const setSelectedOrder = (value: number) =>
    updateState({ ...state, selectedOrder: value });

  const setOrderRT = (value: Partial<RTRequest>) =>
    updateState({ ...state, orderRT: { ...value } });

  const clearOrderRT = () =>
    updateState({ ...state, orderRT: initialRTRequest });

  const setStatus = (value: CargoUIStatus) =>
    updateState({ ...state, status: value });

  return {
    data: state,
    clear,
    setIsOpenDialog,
    setCloseDialog,
    setIsOpenDropDown,
    setOpenCancelDialog,
    setCloseCancelDialog,
    setSelectedOrder,
    setOrderRT,
    clearOrderRT,
    setStatus,
  };
}
